"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkStyles = void 0;
exports.LinkStyles = {
    fontWeight: 600,
    textTransform: 'none',
    textDecoration: 'none',
    color: 'primary.main',
    '&:visited': {
        color: 'inherit',
    },
    '&:hover': {
        cursor: 'pointer',
    },
};
